import { Input } from '@common/ui/mantine'
import { Text } from '@common/ui'
import React from 'react'

export type ReferenceSetListProps = {
  label: string
}

const ReferenceSetList = ({ label }: ReferenceSetListProps) => (
  <Input.Wrapper label={label}>
    <div
      style={{
        maxHeight: 200,
        overflowY: 'auto',
        border: '1px solid var(--trellis-color-text-disabled)',
        borderRadius: 'var(--trellis-radius-sm)',
        padding: 8,
      }}
    >
      <Text c="dimmed">This set is empty</Text>
    </div>
  </Input.Wrapper>
)

export default ReferenceSetList
